export default "__VITE_ASSET__D$cr1v$4__"